import { getCard } from "../../content/lookups.js";
import { ORG_REWARD_POOL } from "../../content/organizations.js";
import { REWARD_POOLS } from "../../content/rewardPools.js";
import type { RewardPools } from "../../domain/types/index.js";
import { flattenPool, type PoolSize } from "./poolCards.js";

export type StoredRewards = {
  small: string[];
  medium: string[];
  large: string[];
  orgs: string[];
};

const SIZES: PoolSize[] = ["small", "medium", "large"];

function splitPool(ids: readonly string[]): { workers: string[]; actions: string[] } {
  const workers: string[] = [];
  const actions: string[] = [];
  for (const id of ids) {
    const card = getCard(id);
    if (card?.type === "worker") workers.push(id);
    else if (card) actions.push(id);
  }
  return { workers, actions };
}

export function defaultStoredRewards(): StoredRewards {
  return {
    small: flattenPool(REWARD_POOLS.small),
    medium: flattenPool(REWARD_POOLS.medium),
    large: flattenPool(REWARD_POOLS.large),
    orgs: [...ORG_REWARD_POOL],
  };
}

export function toStageRewardPools(rewards: StoredRewards | undefined): RewardPools | undefined {
  if (!rewards) return undefined;
  const pools = {} as RewardPools;
  for (const size of SIZES) {
    pools[size] = rewards[size].length === 0 ? REWARD_POOLS[size] : splitPool(rewards[size]);
  }
  return pools;
}

export function toStageOrgPool(rewards: StoredRewards | undefined): readonly string[] | undefined {
  if (!rewards) return undefined;
  return rewards.orgs.length === 0 ? undefined : rewards.orgs;
}
